import { Navigate, Outlet } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { hasSurveysModule } from 'modules/engagement/lib/hasSurveysModule'
import CollectionsBootstrap from 'modules/surveys/lib/CollectionsBootstrap'

const Container = () => {
  const { navigation } = useNavigation()

  const { moduleAvailabilities, upsellFlowEnabled } = useEngagementContext()

  if (!hasSurveysModule(moduleAvailabilities) && !upsellFlowEnabled) {
    return <Navigate to={navigation.discover.marketplaceModules.fullPath()} />
  }

  return <Outlet />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
